import Page from 'views/Home/Home'

export default Page
